import React from 'react';
import { createUseStyles } from 'react-jss';
import { Divider } from 'antd';
import cn from 'classnames';
import { observer } from 'mobx-react';
import { useAppStore } from '../../../stores/root/root.context';
import { ControlBlock } from '../../lab/control-block';
import { Button } from '../ui/button';
import { Dialog, DialogFooter, DialogHeader } from '../ui/dialog';
import { Stack } from '../ui/stack';
import { TextField } from '../ui/text-field';
import { Typography } from '../ui/typography';
import { TagDialogProps } from './dialog-tag.models';

const PREFIX = 'DialogCourseEdit';
const useStyles = createUseStyles(
  () => ({
    root: {},
    cancelBtn: {
      justifyContent: 'center',
      height: '44px',
      fontSize: '16px',
    },
    submitBtn: {
      justifyContent: 'center',
      border: 'none',
      height: '44px',
      fontSize: '16px',
    },
  }),
  { name: PREFIX },
);

export const TagDialog: React.FC<TagDialogProps> = observer((props) => {
  const { className, onClose, onSubmit, ...other } = props;
  const { tagForm: form } = useAppStore();
  const tag = form.getValues();
  const disabledModeration = !form.isValid;

  const classes = useStyles();
  const rootCN = cn(classes.root, className);

  const handleSave = (): void => {
    if (onSubmit) {
      onSubmit();
    }
  };

  return (
    <Dialog color="primary" className={rootCN} onClose={onClose} {...other}>
      <DialogHeader onClose={onClose}>
        <Typography variant="h3" fontWeight="bold">
          Добавить новую запись
        </Typography>
      </DialogHeader>

      <Divider style={{ marginTop: '20px', marginBottom: '28px' }} />

      <Stack direction="column" spacing={24}>
        <ControlBlock
          label="Тэг"
          control={
            <TextField
              fullWidth
              placeholder="Название тэга"
              value={tag.title}
              onChange={(e): void => form.setFieldValue('title', e.target.value) }
            />
          }
        />
      </Stack>

      <DialogFooter>
        <Stack direction="column" spacing={8}>
          <Divider />
          <Stack
            justifyContent="flex-end"
            spacing={16}
          >
            <Button
              variant="outlined"
              className={classes.cancelBtn}
              onClick={onClose}
            >
            Отменить
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.submitBtn}
              onClick={handleSave}
              disabled={disabledModeration}
            >
            Сохранить
            </Button>
          </Stack>
        </Stack>
      </DialogFooter>

    </Dialog>
  );
});
